import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/accounts/store/action.type";

export const AutoRegTableColumnDropAction = createAction(
  ActionType.TABLE_COLUMN_DROP,
  props<{columns: string[]}>()
)
